import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ReportJobsService } from '../../../services/report-jobs.service';
import { ReportHubService } from '../../../services/report-hub.service';
import { ToastService } from '../../../services/toast.service';

@Component({
    selector: 'app-wompi-consolidated-report',
    templateUrl: './wompi-consolidated-report.component.html',
    styleUrls: ['./wompi-consolidated-report.component.scss']
})
export class WompiConsolidatedReportComponent implements OnInit, OnDestroy {
    reportForm!: FormGroup;
    loading = false;

    // Fechas por defecto
    startDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    endDate: Date = new Date();

    private reportHubSub!: Subscription;
    private pendingJobId: string | null = null;

    constructor(
        private fb: FormBuilder,
        private reportJobsService: ReportJobsService,
        private reportHubService: ReportHubService,
        private toastService: ToastService,
    ) { }

    ngOnInit(): void {
        this.initForm();

        this.reportHubSub = this.reportHubService.reportStatusChanged$.subscribe(notification => {
            if (notification.jobId !== this.pendingJobId) return;

            if (notification.status === 'Completed') {
                this.loading = false;
                this.toastService.showToast('success', 'Reporte consolidado Wompi generado exitosamente. Descargando...');
                this.reportJobsService.downloadReport(notification.jobId, notification.fileName || undefined);
                this.pendingJobId = null;
            } else if (notification.status === 'Failed') {
                this.loading = false;
                this.toastService.showToast('error', `Error al generar el reporte: ${notification.errorMessage || 'Desconocido'}`);
                this.pendingJobId = null;
            } else if (notification.status === 'Processing') {
                this.toastService.showToast('info', 'Procesando reporte consolidado Wompi...');
            }
        });
    }

    ngOnDestroy(): void {
        this.reportHubSub?.unsubscribe();
    }

    private initForm(): void {
        this.reportForm = this.fb.group({
            startDate: [this.startDate, Validators.required],
            endDate: [this.endDate, Validators.required]
        });
    }

    onStartDateChange(event: any): void {
        this.startDate = event;
    }

    onEndDateChange(event: any): void {
        this.endDate = event;
    }

    downloadExcelReport(): void {
        if (this.reportForm.invalid) {
            this.reportForm.markAllAsTouched();
            return;
        }

        const formStartDate = this.reportForm.value.startDate;
        const formEndDate = this.reportForm.value.endDate;

        if (!formStartDate || !formEndDate) {
            this.toastService.showToast('warning', 'Por favor seleccione la fecha de inicio y fin');
            return;
        }

        if (formStartDate > formEndDate) {
            this.toastService.showToast('warning', 'La fecha de inicio debe ser menor o igual a la fecha de fin');
            return;
        }

        this.startDate = formStartDate;
        this.endDate = formEndDate;

        this.loading = true;
        this.reportJobsService.queueWompiConsolidatedReport(this.startDate, this.endDate).subscribe({
            next: (response) => {
                this.pendingJobId = response.jobId;
                this.toastService.showToast('info', 'Generando reporte consolidado Wompi en segundo plano...');
            },
            error: (error) => {
                console.error('Error requesting report:', error);
                this.loading = false;
                this.toastService.showToast('error', 'Error al solicitar el reporte');
            }
        });
    }
}
